'use strict';

function controller (modalService) {
    const ctrl = this;
    const MODAL_ID = 'photoLightbox';

    ctrl.$onInit = function () {
        let modal = {
            id: MODAL_ID,
            lockBodyScroll: true,
            closeOthersOnOpen: true
        };

        modalService.register(modal);
    };

    ctrl.isOpen = () => modalService.get(MODAL_ID) && modalService.get(MODAL_ID).isOpen();
}

controller.$inject = [
    'modalService'
];

export default controller;
